const noRepeatPeriod = (value:any) =>{
    const x=value.split("").filter((element:any)=>element==='.')
    return x
}

const NormalizeNumber = (value:any, previousValue:any) => {
    if (!value) {
      return value
    }
    const onlyNums = value.replace(/[^.\d]/g, '')
    if(value[0]==="."){
        return "0."
    }
    else if(value?.includes('.')){
        if(noRepeatPeriod(value).length>1){
            return previousValue
        }
        // return onlyNums
    }
    if(value.includes('%')){
        return onlyNums+'%'
    }
    return onlyNums
  }

 
  
  export default NormalizeNumber